module.exports = "./img/9fe6eebb4233098ddb871f3cb02c70a9.jpg";